<template>
<div v-if="isTgApp || isPWA" class="block mb-3" style="height:52px" :class="(hideHeader) ? 'surface-200' : ''"></div>
<div v-else class="block xl:hidden lg:hidden md:hidden mb-3" style="height:52px"></div>

<FixedMobile>
    <template v-slot:body>
        <div class="flex flex-row w-full gap-3">
            <div class="flex flex-column py-2 gap-1">
                <span class="flex text-900 font-medium text-xl">
                    Перевод
                </span>
                <span v-if="type">
                    <div class="py-1 px-2 flex text-xs border-round-md font-semibold border-none cursor-pointer font-medium align-items-center gap-1" 
                        :class="getMerchantClass(type)">
                        <span class="flex">{{ getMerchantType(type) }}</span>
                        <i v-if="type === 'get'" class="pi pi-arrow-down text-xs font-medium"/>
                        <i v-if="type === 'send'" class="pi pi-arrow-up text-xs font-medium"/>
                        <i v-if="type === 'both'" class="pi pi-sync text-xs font-medium"/>
                    </div>
                </span>
            </div>
            <div class="flex flex-row py-2 gap-2">
                <span v-if="transfer">
                    <div :class="'status-'+transfer.status" 
                        class="py-1 px-2 flex text-xs border-round-md font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                        <span class="flex">{{getStatusLabel(transfer.status)}}</span>
                    </div>
                </span>
                <span v-if="transfer">
                    <div @click="copy(transfer.id)" class="py-1 px-2 flex text-xs border-round-md font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                        <span class="flex">{{get_short_id(transfer.id)}}</span>
                        <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                    </div>
                </span>
            </div>
        </div>
    </template>
</FixedMobile>
    
<Page type="gray" :nopadding="true">
    <template v-slot:body>
        <div v-if="transfer" 
            class="flex flex-column w-full gap-3
                p-3 xl:p-6 lg:p-5 md:p-4 
                xl:border-round-xl lg:border-round-xl">

            <div class="w-full flex-row align-items-center
                hidden xl:flex lg:flex md:flex 
                xl:mb-3 lg:mb-3 md:mb-2">
                <span class="flex text-900 font-medium mr-3 
                    text-3xl xl:text-6xl lg:text-5xl md:text-4xl">
                    Перевод
                </span>
                <span v-if="type">
                    <div :class="getMerchantClass(type)" class="mt-2 ml-2 px-3 h-2rem flex flex-row gap-1 text-sm border-round-lg font-semibold border-0 cursor-pointer font-medium align-items-center">
                        <span class="flex">{{ getMerchantType(type) }}</span>
                        <i v-if="type === 'get'" class="pi pi-arrow-down text-xs font-medium"/>
                        <i v-if="type === 'send'" class="pi pi-arrow-up text-xs font-medium"/>
                        <i v-if="type === 'both'" class="pi pi-sync text-xs font-medium"/>
                    </div>
                </span>
                <span v-if="transfer">
                    <div :class="'status-'+transfer.status" 
                        class="mt-2 ml-2 px-3 h-2rem flex flex-row text-sm border-round-lg font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                        <span class="flex">{{getStatusLabel(transfer.status)}}</span>
                    </div>
                </span>
                <span v-if="transfer">
                    <div @click="copy(transfer.id)" class="mt-2 ml-2 px-3 h-2rem flex flex-row text-sm border-round-lg font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                        <span class="flex">{{get_short_id(transfer.id)}}</span>
                        <span class="flex pi pi-copy ml-2 text-500 text-xl cursor-pointer"></span>
                    </div>
                </span>
            </div>

            <div v-if="type && transfer && (type=='get' || type=='both')" 
                class="w-full flex flex-column xl:flex-row relative">
                <div class="w-full flex flex-column relative surface-0 border-round-xl xl:border-round-2xl p-3 xl:p-4 gap-3">
                    <span class="flex text-sm xl:text-lg text-600">
                        Прием: 
                    </span>
                    <span v-if="transfer.sender && transfer.sender.amount && transfer.sender.currency_code"
                        class="flex text-2xl xl:text-3xl font-semibold text-900 xl:mb-2">
                        {{ get_format_amount(transfer.sender.amount, transfer.sender.currency_code) }}
                    </span>
                    <span v-if="transfer.sender && transfer.sender.fullname" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Имя отправителя:</span>
                        <span class="text-900 font-medium">{{ transfer.sender.fullname }}</span>
                    </span>
                    <span v-if="transfer.sender && transfer.sender.bank_code" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Банк приема:</span>
                        <span class="text-900 font-medium">{{ getBankTitle(transfer.sender.bank_code) }}</span>
                        <img :src="getBankImage(transfer.sender.bank_code)" class="flex" style="width:20px;margin-top:-0.25rem">
                    </span>
                    <span v-if="transfer.dates && transfer.dates.created" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Дата создания:</span>
                        <span class="text-900 font-medium">{{ formatDate(transfer.dates.created) }}</span>
                    </span> 
                    <span v-if="transfer.sender && transfer.sender.description" class="flex text-sm xl:text-lg text-600">
                        <span>Описание: <span class="text-900 font-medium">{{ transfer.sender.description }}</span></span>
                    </span> 
                </div>
            </div>

            <div v-if="canConfirmGet || canConfirmBoth" class="w-full flex gap-3
                flex-column xl:flex-row lg:flex-row md:flex-row">
                
                <!--Подтверждение получения-->
                <Button v-if="canConfirmGet"
                    @click="showConfirmGet()"
                    label="Подтвердить прием" icon="pi pi-check" 
                    class="w-full border-round-xl"
                    severity="primary"
                    :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
                    iconPos="right" />
                
                <!--Подтверждение приема и отправки-->
                <Button v-if="canConfirmBoth"
                    @click="showConfirmBoth()"
                    label="Подтвердить прием и выплату" icon="pi pi-check" 
                    class="w-full border-round-xl"
                    severity="primary"
                    :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
                    iconPos="right" />
            </div>

            <div v-if="type && transfer && transfer.recipient && (type=='send' || type=='both')" 
                class="w-full flex flex-column xl:flex-row relative">
                <div class="w-full flex flex-column relative surface-0 border-round-xl xl:border-round-2xl p-3 xl:p-4 gap-3">
                    <span class="flex text-sm xl:text-lg text-600">
                        К выплате: 
                    </span>
                    <span v-if="transfer.recipient.amount && transfer.recipient.amount && transfer.recipient.currency_code"
                        class="flex text-2xl xl:text-3xl font-semibold text-900 xl:mb-2">
                        {{ get_format_amount(transfer.recipient.amount, transfer.recipient.currency_code) }}
                        <span class="pi pi-copy ml-2 mb-1 text-500 xl:text-xl lg:text-lg md:text-md text-sm cursor-pointer" @click="copy(transfer.recipient.amount)"></span>
                    </span>
                    <span v-if="transfer.recipient.bank_code" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Банк получателя:</span>
                        <span class="text-900 font-medium">{{ getBankTitle(transfer.recipient.bank_code) }}</span>
                        <img :src="getBankImage(transfer.recipient.bank_code)" class="flex" style="width:20px;margin-top:-0.25rem">
                    </span>
                    <div v-if="transfer.recipient.fields" class="w-full flex flex-column gap-3">
                        <span v-if="transfer.recipient.fields.fullname" 
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">Имя получателя:</span>
                            <span class="text-900 font-medium">{{ transfer.recipient.fields.fullname }}</span>
                        </span>
                        <span v-if="transfer.recipient.fields.account_number" 
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">Аккаунт получателя:</span>
                            <span class="text-900 font-medium">{{ transfer.recipient.fields.account_number }}</span>
                            <span class="pi pi-copy ml-2 mb-1 text-500 xl:text-xl lg:text-lg md:text-md text-sm cursor-pointer" @click="copy(transfer.recipient.fields.account_number)"></span>
                        </span>
                        <span v-if="transfer.recipient.fields.card_number"
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">Карта:</span>
                            <span class="text-900 font-medium">{{ format_card(transfer.recipient.fields.card_number) }}</span>
                            <span class="pi pi-copy ml-2 mb-1 text-500 xl:text-xl lg:text-lg md:text-md text-sm cursor-pointer" @click="copy(transfer.recipient.fields.card_number)"></span>
                        </span>
                        <span v-if="transfer.recipient.fields.phone_number"
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">Номер телефона:</span>
                            <span class="font-medium text-900">{{transfer.recipient.fields.phone_number}}</span>
                            <span class="pi pi-copy ml-2 mb-1 text-500 xl:text-xl lg:text-lg md:text-md text-sm cursor-pointer" @click="copy(transfer.recipient.fields.phone_number)"></span>
                        </span>
                        <span v-if="transfer.recipient.fields.wallet_address"
                            class="flex flex-column text-sm xl:text-lg gap-1">
                            <span class="text-600">Адрес кошелька:</span>
                            <div class="flex flex-row gap-1">
                                <span class="font-medium text-900">{{transfer.recipient.fields.wallet_address}}</span>
                                <span class="pi pi-copy ml-2 mb-1 text-500 xl:text-xl lg:text-lg md:text-md text-sm cursor-pointer" @click="copy(transfer.recipient.fields.wallet_address)"></span>
                            </div>
                        </span>
                        <span v-if="transfer.recipient.fields.wallet_network" 
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">Сеть кошелька:</span>
                            <span class="font-medium text-900">{{transfer.recipient.fields.wallet_network}}</span>
                        </span>

                        <!-- telegram -->
                        <span v-if="transfer.recipient.fields.telegram" 
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">Telegram:</span>
                            <span class="font-medium text-900">{{transfer.recipient.fields.telegram}}</span>
                        </span>
                        <!-- bank_name -->
                        <span v-if="transfer.recipient.fields.bank_name" 
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">Название банка:</span>
                            <span class="font-medium text-900">{{transfer.recipient.fields.bank_name}}</span>
                        </span>
                        <!-- address -->
                        <span v-if="transfer.recipient.fields.address" 
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">Адрес:</span>
                            <span class="font-medium text-900">{{transfer.recipient.fields.address}}</span>
                        </span>
                        <!-- city -->
                        <span v-if="transfer.recipient.fields.city" 
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">Город:</span>
                            <span class="font-medium text-900">{{transfer.recipient.fields.city}}</span>
                        </span>
                        <!-- country -->
                        <span v-if="transfer.recipient.fields.country" 
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">Страна:</span>
                            <span class="font-medium text-900">{{transfer.recipient.fields.country}}</span>
                        </span>
                        <!-- swift_code -->
                        <span v-if="transfer.recipient.fields.swift_code" 
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">SWIFT:</span>
                            <span class="font-medium text-900">{{transfer.recipient.fields.swift_code}}</span>
                        </span>
                        <!-- iban_number -->
                        <span v-if="transfer.recipient.fields.iban_number"
                            class="flex text-sm xl:text-lg gap-1">
                            <span class="text-600">IBAN:</span>
                            <span class="font-medium text-900">{{transfer.recipient.fields.iban_number}}</span>
                        </span>
                    </div>
                    <span v-if="transfer.recipient.description"
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Описание:</span>
                        <span class="text-900 font-medium">{{ transfer.recipient.description }}</span>
                    </span>
                </div>
            </div>

            <div v-if="canConfirmSend || canReject" class="w-full flex gap-3
                flex-column xl:flex-row lg:flex-row md:flex-row">

                <!--Отказ-->
                <Button v-if="canReject"
                    @click="showReject()"
                    label="Отказаться от перевода" icon="pi pi-times" 
                    class="w-full border-round-xl"
                    severity="danger"
                    :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
                    iconPos="right" />
                    
                <!--Подтверждение отправки-->
                <Button v-if="canConfirmSend"
                    @click="showConfirmSend()"
                    label="Подтвердить выплату" icon="pi pi-check" 
                    class="w-full border-round-xl"
                    severity="primary"
                    :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
                    iconPos="right" />
            </div>

            <!--карта-->
            <div v-if="card" class="w-full flex flex-column xl:flex-row relative">
                <div class="w-full flex flex-column relative surface-0 border-round-xl xl:border-round-2xl p-3 xl:p-4">
                    <span class="flex text-sm xl:text-lg text-600 mb-3">
                        Реквизиты приема: 
                    </span>
                    <Card :card="card" v-if="card" />
                </div>
            </div>

            <!-- чеки -->
            <div class="w-full flex flex-column xl:flex-row relative">
                <div class="w-full flex flex-column relative surface-0 gap-2
                    border-round-xl xl:border-round-2xl
                    p-3 xl:p-4">
                    <span class="flex text-sm xl:text-lg text-600">
                        Файлы: 
                    </span>
                    <div class="w-full flex flex-row overflow-hidden" v-if="files && files.length">
                        <div v-for="file in files" 
                            class="flex flex-column gap-2 mr-2 w-full max-w-6rem surface-0 border-1 border-300 border-round-lg p-2 relative cursor-pointer">
                            <span class="flex flex-column text-xs text-600">
                                <span class="flex">{{ getShortName(file.name) }}</span><br>
                                <span class="flex">{{ formatSize(file.size) }}</span>
                            </span>
                            <Button :label="'открыть'" @click="openPopup(file.path, file.name)" class="border-round-lg border-none " icon="pi pi-eye" size="small" iconPos="right" text severity="info"/>
                            <Button :label="'скачать'" @click="downloadFile(file.path, file.name)" class="border-round-lg border-none " icon="pi pi-download" size="small" iconPos="right" text severity="info"/>
                        </div>
                    </div>
                    <!--FILES UPLOAD-->
                    <AddReceipt :id="transferId" :showMessage="false" from="merchant"/>
                </div>
            </div>
            <Skeleton v-if="files==null" height="3rem" class="border-round-xl"/>

            <!--отметки-->
            <div class="w-full flex flex-column xl:flex-row relative">
                <div class="w-full flex flex-column relative surface-0 border-round-xl xl:border-round-2xl p-3 xl:p-4 gap-3">
                    <span v-if="(type=='get' || type=='both') && transfer.send && transfer.send.merchant && transfer.send.merchant.amount" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">К списанию с депозита:</span>
                        <span class="text-900 font-medium">{{ get_format_amount(transfer.send.merchant.amount, 'usdt') }}</span>
                    </span>
                    <span v-if="(type=='send' || type=='both') && transfer.send && transfer.send.merchant && transfer.send.merchant.amount" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">К начислению на счет:</span>
                        <span class="text-900 font-medium">{{ get_format_amount(transfer.send.merchant.amount, 'usdt') }}</span>
                    </span>
                    <span v-if="transfer.send && transfer.send.merchant && transfer.send.merchant.amount" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Курс биржи:</span>
                        <span class="text-900 font-medium">{{getTotalRate(transfer)}}</span>
                    </span>
                    <span v-if="(type=='get' || type=='both') && transfer && transfer.get.merchant.reward_amount" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Комиссия сервиса за прием:</span>
                        <span class="text-900 font-medium">{{ get_format_amount(transfer.get.merchant.reward_amount, 'usdt') }}</span>
                    </span> 
                    <span v-if="(type=='send' || type=='both') && transfer && transfer.send && transfer.send.merchant && transfer.send.merchant.reward_amount" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Комиссия сервиса за отправку:</span>
                        <span class="text-900 font-medium">{{ get_format_amount(transfer.send.merchant.reward_amount, 'usdt') }}</span>
                    </span> 
                    <span v-if="(type=='send' || type=='both') && transfer && transfer.send.merchant.bank_amount" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Комиссия банка:</span>
                        <span class="text-900 font-medium">{{ get_format_amount(transfer.send.merchant.bank_amount, 'usdt') }}</span>
                    </span> 
                    <span v-if="transfer.send && transfer.send.merchant && transfer.send.merchant.amount" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Курс с комиссиями:</span>
                        <span class="text-900 font-medium">{{getTotalRateComission(transfer)}}</span>
                    </span>
                    <span v-if="transfer.send && transfer.send.merchant && transfer.send.merchant.amount" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Сумма с комиссиями:</span>
                        <span class="text-900 font-medium">{{getFullAmount(transfer)}}</span>
                    </span>
                    
                    <span v-if="transfer.sender && transfer.sender.confirm_date" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Отметка клиентом:</span>
                        <span :class="(transfer.sender.confirm) ? 'bg-green-500' : 'bg-orange-500'" class="inline -mt-1 text-white px-2 py-1 border-round-md">
                            {{ (transfer.sender.confirm) ? 'Да' : 'Нет' }}
                        </span><br>
                        <span>&nbsp{{ (transfer.sender.confirm_date) ? formatDate(transfer.sender.confirm_date) : ''}}</span>
                    </span>
                    <span v-if="transfer.get && transfer.get.merchant && transfer.get.merchant.confirm!==undefined" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Отметка мерчантом получения:</span>
                        <span :class="(transfer.get.merchant.confirm) ? 'bg-green-500' : 'bg-orange-500'" class="inline -mt-1 text-white px-2 py-1 border-round-md">
                            {{ (transfer.get.merchant.confirm) ? 'Да' : 'Нет' }}
                        </span><br>
                        <span>&nbsp{{ (transfer.get.merchant.confirm_date) ? formatDate(transfer.get.merchant.confirm_date) : ''}}</span>
                    </span>
                    <span v-if="transfer.send && transfer.send.merchant && transfer.send.merchant.confirm!==undefined" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Отметка мерчантом отправки:</span>
                        <span :class="(transfer.send.merchant.confirm) ? 'bg-green-500' : 'bg-orange-500'" class="inline -mt-1 text-white px-2 py-1 border-round-md">
                            {{ (transfer.send.merchant.confirm) ? 'Да' : 'Нет' }}
                        </span><br>
                        <span>&nbsp{{ (transfer.send.merchant.confirm_date) ? formatDate(transfer.send.merchant.confirm_date) : ''}}</span>
                    </span>
                    <span v-if="(type=='get' || type=='both') && transfer.get && transfer.get.merchant && transfer.get.merchant.reward_paid!=undefined" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Выплата комиссии:</span>
                        <span :class="(transfer.get.merchant.reward_paid) ? 'bg-green-500' : 'bg-orange-500'" class="inline -mt-1 text-white px-2 py-1 border-round-md">
                            {{ (transfer.get.merchant.reward_paid) ? 'Да' : 'Нет' }}
                        </span>
                    </span>
                    <span v-if="(type=='send' || type=='both') && transfer && transfer.send.merchant && transfer.send.merchant.reward_paid!=undefined" 
                        class="flex text-sm xl:text-lg gap-1">
                       <span class="text-600">Выплата комиссии за отправку:</span>
                        <span :class="(transfer.send.merchant.reward_paid) ? 'bg-green-500' : 'bg-orange-500'" class="inline -mt-1 text-white px-2 py-1 border-round-md">
                            {{ (transfer.send.merchant.reward_paid) ? 'Да' : 'Нет' }}
                        </span>
                    </span> 
                    <span v-if="(type=='send' || type=='both') && transfer && transfer.send.merchant && transfer.send.merchant.bank_paid!=undefined" 
                        class="flex text-sm xl:text-lg gap-1">
                        <span class="text-600">Выплата комиссии банка:</span>
                        <span :class="(transfer.send.merchant.bank_paid) ? 'bg-green-500' : 'bg-orange-500'" class="inline -mt-1 text-white px-2 py-1 border-round-md">
                            {{ (transfer.send.merchant.bank_paid) ? 'Да' : 'Нет' }}
                        </span>
                    </span>                      
                </div>
            </div>
        </div>
        <div v-else-if="!transfer && !loaded" class="w-full px-3">
            <Skeleton  class="w-full" height="3rem" />
        </div>
    </template>
</Page>

<!--Confirm Get-->
<Dialog v-if="transfer" v-model:visible="confirmGet" modal header="Подтверждение приема" 
    class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
    <div class="flex w-full flex-row">
        <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
            <Button label="Отменить"
                @click="closePopups()"
                :disabled="isLoading"
                severity="secondary"
                :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
                class="border-round-lg border-none text-sm" />
        </div>
        <div class="flex w-full my-2">
            <Button v-if="canConfirmGet"
                label="Подтвердить прием"
                @click="Confirm('get')"
                :loading="isLoading" :disabled="isLoading"
                severity="primary"
                :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
                class="flex flex-1 border-round-lg border-none text-sm" />
        </div>
    </div>
</Dialog>

<!--Confirm Send-->
<Dialog v-if="transfer" v-model:visible="confirmSend" modal header="Подтверждение выплаты" 
    class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
    <div class="flex w-full flex-row">
        <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
            <Button label="Отменить"
                @click="closePopups()"
                :disabled="isLoading"
                severity="secondary"
                :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
                class="border-round-lg border-none text-sm" />
        </div>
        <div class="flex w-full my-2">
            <Button v-if="canConfirmSend"
                label="Подтвердить выплату"
                @click="Confirm('send')"
                :loading="isLoading" :disabled="isLoading"
                severity="primary"
                :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
                class="flex flex-1 border-round-lg border-none text-sm" />
        </div>
    </div>
</Dialog>

<!--Confirm Send-->
<Dialog v-if="transfer" v-model:visible="confirmBoth" modal header="Подтверждение приема и выплаты" 
    class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
    <div class="flex w-full flex-row">
        <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
            <Button label="Отменить"
                @click="closePopups()"
                :disabled="isLoading"
                severity="secondary"
                :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
                class="border-round-lg border-none text-sm" />
        </div>
        <div class="flex w-full my-2">
            <Button v-if="canConfirmBoth"
                label="Подтвердить прием и выплату"
                @click="Confirm('both')"
                :loading="isLoading" :disabled="isLoading"
                severity="primary"
                :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
                class="flex flex-1 border-round-lg border-none text-sm" />
        </div>
    </div>
</Dialog>

<!--Reject popup-->
<Dialog v-if="transfer" v-model:visible="rejectPopup" modal header="Отказ от выплаты" 
    class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
    <div class="flex w-full flex-row">
        <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
            <Button label="Отменить"
                @click="rejectPopup=false"
                :loading="isLoading" :disabled="isLoading"
                severity="secondary"
                :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
                class="flex border-round-lg border-none" />
        </div>
        <div class="flex w-full my-2">
            <Button label="Отказаться"
            @click="Reject()"
            :loading="isLoading" :disabled="isLoading"
            severity="danger"
            :size="(screenSize === 'xl' || screenSize === 'lg') ? 'large' : ''"
            class="flex w-full border-round-lg border-none" />
        </div>
    </div>
</Dialog>

<!--Files-->
<Dialog header="file" v-model:visible="popupFile" modal 
    class="border-none"
    :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" >
    <img :src="file_url" class="w-full">
</Dialog>
</template>
<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { useRoute } from 'vue-router'
import BigNumber from 'bignumber.js'
import Card from '@/components/merchant/CardWidget.vue'
import Page from '@/components/sides/Page.vue' 
import FixedMobile from '@/components/sides/header/FixedMobile.vue'
import AddReceipt from '@/components/widgets/transfer/AddReceipt.vue'
import { BankList } from '@/assets/js/classes/PaymentSystem.js'

export default {
    name: 'TransferCreate',
    data() {
        return {
            transferId: null,
            transfer: null,
            type: null,
            confirmGet: false,
            confirmSend: false,
            confirmBoth: false,
            rejectPopup: false,
            isLoading: false,
            status: null,
            card: null,
            loaded: false,
            files: [],
            popupFile: false,
            file_url: null,
            bank_list: []
        }
    },
    components: {
        Card,
        Page,
        FixedMobile,
        AddReceipt
    },
    methods: {
        go_transfers(){
            this.$router.push({path: '/merchant/transfers/'})
        },
        showConfirmGet(){
            this.confirmGet = true
        },
        showConfirmSend(){
            this.confirmSend = true
        },
        showConfirmBoth(){
            this.confirmBoth = true
        },
        showReject(){
            this.rejectPopup = true
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
        get_short_id(value){
            return this.helper.get_short_id(value)
        },
        get_payment_type_label(code){
            return this.helper.get_payment_type_label(code)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        getStatusLabel (status) {
            return this.helper.get_severity_status(status, 'ru')
        },
        phone_mask(phone, cur){
            return this.helper.phone_mask(phone, cur)
        },
        format_card(number){
            return this.helper.format_card(number)
        },
        formatDate(value){
            return this.helper.format_date_short(value)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        getMerchantType(type) {
            return (type=='get') ? 'прием' : (type=='send') ? 'выплата' : (type=='both') ? 'круг' : '-'
        },
        getMerchantClass(type){
            return (type=='get') ? 'bg-blue-50 text-blue-600' : (type=='send') ? 'bg-orange-50 text-orange-600' : (type=='both') ? 'bg-green-50 text-green-600' : ''
        },
        getTotalRate(data){
            if(!data || !data.merchant_type) return ''

            if(data.merchant_type=='get' && data.get && data.get.merchant && data.get.merchant.amount){
                let getSenderAmount = (data.sender.amount) ? new BigNumber(data.sender.amount) : new BigNumber(0)
                let serviceAmount = (data.service.amount) ? new BigNumber(data.service.amount) : new BigNumber(0)
                let getRate = getSenderAmount.dividedBy(serviceAmount)
                return this.helper.format_rate(getRate, 2)
            }

            if(data.merchant_type=='send' && data.send && data.send.merchant && data.send.merchant.amount){
                let sendMerchantAmount = (data.send.merchant.amount) ? new BigNumber(data.send.merchant.amount) : new BigNumber(0)
                let recipientAmount = (data.recipient.amount) ? new BigNumber(data.recipient.amount) : new BigNumber(0)
                let sendRate = sendMerchantAmount.dividedBy(recipientAmount)
                if(sendRate.isLessThan(1)) sendRate = new BigNumber(1).dividedBy(sendRate)
                return this.helper.format_rate(sendRate, 2)
            }

            if(data.merchant_type=='both' && data.sender && data.sender.amount && data.recipient && data.recipient.amount){
                let getSenderAmount = (data.sender.amount) ? new BigNumber(data.sender.amount) : new BigNumber(0)
                let serviceAmount = (data.service.amount) ? new BigNumber(data.service.amount) : new BigNumber(0)
                let getRate = getSenderAmount.dividedBy(serviceAmount)
                if(getRate.isLessThan(1)) getRate = new BigNumber(1).dividedBy(getRate)

                let sendMerchantAmount = (data.send.merchant.amount) ? new BigNumber(data.send.merchant.amount) : new BigNumber(0)
                let sendRecipientAmount = (data.recipient.amount) ? new BigNumber(data.recipient.amount) : new BigNumber(0)
                
                let sendRate = sendMerchantAmount.dividedBy(sendRecipientAmount)
                if(sendRate.isLessThan(1)) sendRate = new BigNumber(1).dividedBy(sendRate)

                return `${this.helper.format_rate(getRate, 2)} / ${this.helper.format_rate(sendRate, 2)}`
            }

            return ''
        },
        getTotalRateComission(data){
            if(!data || !data.merchant_type) return ''

            if(data.merchant_type=='get' && data.get && data.get.merchant && data.get.merchant.amount){
                let senderAmount = (data.sender.amount) ? new BigNumber(data.sender.amount) : new BigNumber(0)
                let serviceAmount = (data.service.amount) ? new BigNumber(data.service.amount) : new BigNumber(0)
                let rate = senderAmount.dividedBy(serviceAmount) // текущий курс на момент создания перевода
                if(rate.isLessThan(1)) rate = new BigNumber(1).dividedBy(rate)

                let getMerchantAmount = (data.get.merchant.amount) ? new BigNumber(data.get.merchant.amount) : new BigNumber(0)
                let getComission = (data.get.merchant.reward_amount) ? new BigNumber(data.get.merchant.reward_amount) : new BigNumber(0)
                let totalGetAmount = getMerchantAmount.plus(getComission)
                let getMerchantCurAmount = getMerchantAmount.multipliedBy(rate)

                let getRate = getMerchantCurAmount.dividedBy(totalGetAmount)
                return this.helper.format_rate(getRate, 2)
            }

            if(data.merchant_type=='send' && data.send && data.send.merchant && data.send.merchant.amount){
                let sendMerchantAmount = (data.send.merchant.amount) ? new BigNumber(data.send.merchant.amount) : new BigNumber(0)
                let recipientAmount = (data.recipient.amount) ? new BigNumber(data.recipient.amount) : new BigNumber(0)
                let sendComission = (data.send.merchant.reward_amount) ? new BigNumber(data.send.merchant.reward_amount) : new BigNumber(0)
                let sendTotalAmount = sendMerchantAmount.plus(sendComission)
                let sendRate = sendTotalAmount.dividedBy(recipientAmount)
                if(sendRate.isLessThan(1)) sendRate = new BigNumber(1).dividedBy(sendRate)
                return this.helper.format_rate(sendRate, 2)
            }

            if(data.merchant_type=='both' && data.sender && data.sender.amount && data.recipient && data.recipient.amount){
                let senderAmount = (data.sender.amount) ? new BigNumber(data.sender.amount) : new BigNumber(0)
                let serviceAmount = (data.service.amount) ? new BigNumber(data.service.amount) : new BigNumber(0)
                let rate = senderAmount.dividedBy(serviceAmount) // текущий курс на момент создания перевода
                if(rate.isLessThan(1)) rate = new BigNumber(1).dividedBy(rate)

                let getMerchantAmount = (data.get.merchant.amount) ? new BigNumber(data.get.merchant.amount) : new BigNumber(0)
                let getComission = (data.get.merchant.reward_amount) ? new BigNumber(data.get.merchant.reward_amount) : new BigNumber(0)
                let totalGetAmount = getMerchantAmount.plus(getComission)
                let getMerchantCurAmount = getMerchantAmount.multipliedBy(rate)
                let getRate = getMerchantCurAmount.dividedBy(totalGetAmount)
                if(getRate.isLessThan(1)) getRate = new BigNumber(1).dividedBy(getRate)

                let sendMerchantAmount = (data.send.merchant.amount) ? new BigNumber(data.send.merchant.amount) : new BigNumber(0)
                let recipientAmount = (data.recipient.amount) ? new BigNumber(data.recipient.amount) : new BigNumber(0)
                let sendComission = (data.send.merchant.reward_amount) ? new BigNumber(data.send.merchant.reward_amount) : new BigNumber(0)
                let sendTotalAmount = sendMerchantAmount.plus(sendComission)
                let sendRate = sendTotalAmount.dividedBy(recipientAmount)
                if(sendRate.isLessThan(1)) sendRate = new BigNumber(1).dividedBy(sendRate)

                return `${this.helper.format_rate(getRate, 2)} / ${this.helper.format_rate(sendRate, 2)}`
            }

            return ''
        },
        getFullAmount(data){
            if(!data || !data.merchant_type) return ''

            let total = new BigNumber(0)

            if(data.merchant_type=='get' && data.get && data.get.merchant && data.get.merchant.amount){
                let amount = new BigNumber(data.get.merchant.amount)
                let comission = (data.get.merchant.reward_amount) ? new BigNumber(data.get.merchant.reward_amount) : new BigNumber(0)
                total = amount.plus(comission)
                return this.helper.format_amount(total, 'usdt')
            }

            if(data.merchant_type=='send' && data.send && data.send.merchant && data.send.merchant.amount){
                let amount = new BigNumber(data.send.merchant.amount)
                let sendComission = (data.send.merchant.reward_amount) ? new BigNumber(data.send.merchant.reward_amount) : new BigNumber(0)
                total = amount.plus(sendComission)
                return this.helper.format_amount(total, 'usdt')
            }

            if(data.merchant_type=='both' && data.send && data.send.merchant && data.send.merchant.amount && data.get && data.get.merchant && data.get.merchant.amount){
                let amount = new BigNumber(data.send.merchant.amount)
                let getComission = (data.get.merchant.reward_amount) ? new BigNumber(data.get.merchant.reward_amount) : new BigNumber(0)
                let sendComission = (data.send.merchant.reward_amount) ? new BigNumber(data.send.merchant.reward_amount) : new BigNumber(0)
                total = amount.plus(getComission).plus(sendComission)
                return this.helper.format_amount(total, 'usdt')
            }

            return ''
        },
        formatSize(bytes) {
            const k = 1024;
            const dm = 3;
            const sizes = this.$primevue.config.locale.fileSizeTypes;

            if (bytes === 0) {
                return `0 ${sizes[0]}`;
            }

            const i = Math.floor(Math.log(bytes) / Math.log(k));
            const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

            return `${formattedSize} ${sizes[i]}`;
        },
        getShortName(name){
            if(name.length > 20){
                return '...' + name.slice(-8)
            } else {
                return name
            }
        },
        openPopup(path) {
            if(!path) return
            this.popupFile = true
            this.getFile(path)
        },
        downloadFile(path, name) {
            if(!path) return
            if(!name) return
            this.saveFile(path, name)
        },
        async saveFile(path, name) {
            if(!path) return
            if(!name) return
            const file = await this.connect.merchant_get_file(path).then(res => res)
            if (file) {
                const url = window.URL.createObjectURL(new Blob([file]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', name)
                document.body.appendChild(link)
                link.click()
            } else {
                this.file_url = null
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Файл не найден', life: 3000 })
            }
        },
        async getFile(path) {
            if(!path) return
            const file = await this.connect.merchant_get_file(path).then(res => res)
            if (file) {
                const url = window.URL.createObjectURL(new Blob([file]))
                this.file_url = url
            } else {
                this.file_url = null
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Файл не найден', life: 3000 })
            }
        },
        async Confirm(direction){
            if(!this.transfer || !direction) {
                this.showMess('error', 'Ошибка', 'Не указан тип')
                return
            }
            this.isLoading = true
            try {
                const confirm = await this.connect.transfer_confirm_by_merchant(this.transfer.id, direction).then(res=>res)
                if(confirm.result){
                    this.showMess('success', 'Успех', 'Подтверждено')
                    this.GetTransfer(this.transferId)
                }else{
                    if(confirm.message) this.showMess('error', 'Ошибка', confirm.message)
                    else this.showMess('error', 'Ошибка', 'Ошибка при подтверждении')
                }
                this.isLoading = false
                this.closePopups()
            }catch(e){
                this.isLoading = false
            }
        },
        async Reject(){
            this.isLoading = true
            try {
                const reject = await this.connect.transfer_reject_by_merchant(this.transfer.id).then(res=>res)
                if(reject.result){
                    this.showMess('success', 'Успех', 'Отклонено')
                    this.rejectPopup = false
                    this.go_transfers()
                }else{
                    if(reject.message) this.showMess('error', 'Ошибка', reject.message)
                    else this.showMess('error', 'Ошибка', 'Ошибка при отклонении')
                }
            } catch(e){
                this.showMess('error', 'Ошибка', 'Ошибка при отклонении')  
            }
            this.isLoading = false
        },
        async GetTransfer(id){
            if(!id) return
            this.loading = true
            try {
                const transfer = await this.connect.transfer_getby_merchant(id).then(res=>res)
                if(transfer.result && transfer.data) {
                    this.transfer = transfer.data                
                    this.type = transfer.data.merchant_type
                    if((this.type=='get' || this.type=='both') && (this.transfer.get && this.transfer.get.merchant && this.transfer.get.merchant.card_id) ){
                        this.GetCard(this.transfer.get.merchant.card_id)
                    }
                } else {
                    if(transfer.message) this.showMess('error', 'Ошибка', transfer.message)
                    else this.showMess('error', 'Ошибка', 'Ошибка при получении перевода')
                }
                this.loading = false
            } catch (error) {
                this.loading = false
            }
        },
        async GetCard(id){
            if(!id) return
            try {
                const card = await this.connect.card_getby_merchant(id).then(res=>res)
                if(card.result && card.data) this.card = card.data
                else this.card = null
            } catch (error) {
                console.error('Error fetching card:', error)
            }
        },
        async GetFiles(id){
            if(!id) return
            try {
                const files = await this.connect.merchant_files_list(10, 0, {transfer_id: id}, {}).then(res => res)
                if (files.result && files.data.length > 0) this.files = files.data
                else this.files = []
            } catch (error) {
                console.error('Error fetching files:', error)
            }
        },
        closePopups(){
            this.confirmGet = false
            this.confirmSend = false
            this.confirmBoth = false
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetTitle(code, this.lang_)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : null
        },
        async LoadBankList(){
            this.bank_list = await BankList.GetList(this.$store).then(r=>r)
            if(!this.bank_list || !this.bank_list.length) this.bank_list = []
        },
    },
    computed: {
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        screenSize() { return this.$store.getters.StateScreenSize },
        canConfirmGet() {
            if(!this.transfer || !this.type) return false
            if(this.type != 'get' && this.type != 'both') return false
            if(!this.transfer.sender || !this.transfer.sender.confirm) return false
            if(!this.transfer.get || this.transfer.get.type !== 'merchant') return false
            if(!this.transfer.get.merchant || this.transfer.get.merchant.confirm) return false
            return true
        },
        canConfirmSend() {
            if(!this.transfer || !this.type) return false
            if(this.type != 'send' && this.type != 'both') return false
            if(!this.transfer.sender || !this.transfer.sender.confirm) return false
            if(!this.transfer.get || !this.transfer.get.type) return false
            if(this.transfer.get.type === 'merchant' && !this.transfer.get.merchant?.confirm) return false
            if(this.transfer.get.type === 'payment_system' && !this.transfer.get.payment_system?.confirm) return false
            if(this.transfer.get.type !== 'merchant' && this.transfer.get.type !== 'payment_system') return false
            if(!this.transfer.send || !this.transfer.send.merchant || this.transfer.send.merchant.confirm) return false
            return true
        },
        canConfirmBoth() {
            if(!this.transfer || !this.type) return false
            if(this.type != 'both') return false
            if(!this.transfer.sender || !this.transfer.sender.confirm) return false
            if(!this.transfer.get || !this.transfer.get.type) return false
            if(this.transfer.get.type === 'merchant' && this.transfer.get.merchant?.confirm) return false
            if(this.transfer.get.type === 'payment_system' && this.transfer.get.payment_system?.confirm) return false
            if(this.transfer.get.type !== 'merchant' && this.transfer.get.type !== 'payment_system') return false
            if(!this.transfer.send || !this.transfer.send.merchant || this.transfer.send.merchant.confirm) return false
            return true
        },
        canReject() {
            if(!this.transfer || !this.type) return false
            if(this.type != 'send' && this.type != 'both') return false
            if(!this.transfer.sender || !this.transfer.sender.confirm) return false
            if(!this.transfer.get || !this.transfer.get.type) return false

            let isGetConfirmed = false
            if(this.transfer.get.type === 'merchant') {
                isGetConfirmed = this.transfer.get.merchant?.confirm === true
            } else if(this.transfer.get.type === 'payment_system') {
                isGetConfirmed = this.transfer.get.payment_system?.confirm === true
            }
            if(!isGetConfirmed) return false

            if(!this.transfer.send || !this.transfer.send.merchant || this.transfer.send.merchant.confirm) return false
            return true
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)) this.transferId = route.params.id

        if(this.transferId){
            await this.GetTransfer(this.transferId).then(res=>res)
            await this.GetFiles(this.transferId).then(res=>res)
        }

        try { this.LoadBankList()
        } catch (e) { console.log('error', e) }
    },
}
</script>

 

